document.addEventListener('DOMContentLoaded', () => {
    const scheduleEvents = document.querySelectorAll('.schedule-event');
    
    scheduleEvents.forEach(event => {
        event.addEventListener('click', function() {
            const content = this.nextElementSibling;
            
            // Close all other open events
            document.querySelectorAll('.event-content').forEach(c => {
                if (c !== content) {
                    c.classList.remove('is-open');
                }
            });
            
            // Toggle this event
            content.classList.toggle('is-open');
        });
    });
});